var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { v4 } from 'uuid';
export var GERMAN_FEDERAL_STATES;
(function (GERMAN_FEDERAL_STATES) {
    GERMAN_FEDERAL_STATES["UNKNOWN"] = "UNKNOWN";
    GERMAN_FEDERAL_STATES["BAYERN"] = "BAYERN";
    GERMAN_FEDERAL_STATES["NIEDERSACHSEN"] = "NIEDERSACHSEN";
    GERMAN_FEDERAL_STATES["BADEN_WURTTEMBERG"] = "BADEN_WURTTEMBERG";
    GERMAN_FEDERAL_STATES["NORDRHEIN_WESTFALEN"] = "NORDRHEIN_WESTFALEN";
    GERMAN_FEDERAL_STATES["BRANDENBURG"] = "BRANDENBURG";
    GERMAN_FEDERAL_STATES["MECKLENBURG_VORPOMMERN"] = "MECKLENBURG_VORPOMMERN";
    GERMAN_FEDERAL_STATES["HESSEN"] = "HESSEN";
    GERMAN_FEDERAL_STATES["SACHSEN_ANHALT"] = "SACHSEN_ANHALT";
    GERMAN_FEDERAL_STATES["RHEINLAND_PFALZ"] = "RHEINLAND_PFALZ";
    GERMAN_FEDERAL_STATES["SACHSEN"] = "SACHSEN";
    GERMAN_FEDERAL_STATES["THURINGEN"] = "THURINGEN";
    GERMAN_FEDERAL_STATES["SCHLESWIG_HOLSTEIN"] = "SCHLESWIG_HOLSTEIN";
    GERMAN_FEDERAL_STATES["SAARLAND"] = "SAARLAND";
    GERMAN_FEDERAL_STATES["BERLIN"] = "BERLIN";
    GERMAN_FEDERAL_STATES["HAMBURG"] = "HAMBURG";
    GERMAN_FEDERAL_STATES["BREMEN"] = "BREMEN";
})(GERMAN_FEDERAL_STATES || (GERMAN_FEDERAL_STATES = {}));
export var additionalChargeService = {
    getInitialCalculations: function (mortgageCaseMeta) {
        return __awaiter(this, void 0, Promise, function () {
            var caseId;
            return __generator(this, function (_a) {
                caseId = mortgageCaseMeta.caseId;
                return [2 /*return*/, axios.get("/api/recommendation/".concat(caseId, "/project"))];
            });
        });
    },
    makeCalculations: function (baseCost, additionalCost, availableEquity, loanAmount, federalState, mortgageCaseMeta) {
        return __awaiter(this, void 0, Promise, function () {
            var caseId;
            return __generator(this, function (_a) {
                caseId = mortgageCaseMeta.caseId;
                return [2 /*return*/, axios.post("/api/recommendation/".concat(caseId, "/project"), {
                        caseId: caseId,
                        recommendationCalculation: {
                            purchasePrice: baseCost,
                            additionalCosts: additionalCost,
                            asset: availableEquity,
                            loanAmount: loanAmount,
                            federalState: federalState,
                        },
                    })];
            });
        });
    },
    saveDecision: function (mortgageCaseMeta, loanAmount, availableEquity) {
        return __awaiter(this, void 0, Promise, function () {
            var caseId;
            return __generator(this, function (_a) {
                caseId = mortgageCaseMeta.caseId;
                if (loanAmount > 0) {
                    return [2 /*return*/, axios.post("/api/recommendation/".concat(caseId, "/loan"), {
                            loanValue: loanAmount,
                        })];
                }
                if (availableEquity > 0) {
                    return [2 /*return*/, axios.post("/api/recommendation/".concat(caseId, "/asset"), {
                            assetvalue: availableEquity,
                        })];
                }
                return [2 /*return*/, Promise.resolve()];
            });
        });
    },
    mapProjectRecommendationDTOtoAdditionalChargeData: function (projectRecommendation) {
        var additionalCosts = projectRecommendation.additionalCosts, asset = projectRecommendation.asset, loan = projectRecommendation.loan, purchasePrice = projectRecommendation.purchasePrice, underFunding = projectRecommendation.underFunding, serviceCharges = projectRecommendation.serviceCharges, federalStates = projectRecommendation.federalStates;
        return __assign(__assign({ additionalCost: additionalCosts, availableEquity: asset, loanAmount: loan, purchasePrice: purchasePrice, underfunding: underFunding }, serviceCharges), { federalState: federalStates[0], requestId: v4() });
    },
};
